import * as React from 'react';

const CardLogo = () => (
  <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M16.5 33C25.6127 33 33 25.6127 33 16.5C33 14.5863 32.6742 12.7487 32.0751 11.0396L11.0396 32.0751C12.7487 32.6742 14.5863 33 16.5 33ZM3.16676 26.2217L11.2627 18.1258L1.91481 8.7779C0.692428 11.0819 0 13.7101 0 16.5C0 20.1349 1.17536 23.4952 3.16676 26.2217ZM8.7779 1.91481L18.1258 11.2627L26.2217 3.16676C23.4952 1.17536 20.1349 0 16.5 0C13.7101 0 11.0819 0.692428 8.7779 1.91481Z" fill="#FDBF5A"/>
    <path d="M5.43872 5.48047L7.4804 7.52215" stroke="#FDBF5A" strokeWidth="2"/>
    <path d="M9.8064 26.4485L7.76471 28.4902" stroke="#FDBF5A" strokeWidth="2"/>
    <path d="M13.446 22.5662L11.4044 24.6078" stroke="#FDBF5A" strokeWidth="2"/>
    <path d="M17.0859 18.6838L15.0443 20.7255" stroke="#FDBF5A" strokeWidth="2"/>
    <path d="M24.3652 10.9192L22.3235 12.9609" stroke="#FDBF5A" strokeWidth="2"/>
    <path d="M28.0049 7.03687L25.9632 9.07855" stroke="#FDBF5A" strokeWidth="2"/>
    <path d="M9.2207 9.2207L11.2624 11.2624" stroke="#FDBF5A" strokeWidth="2"/>
    <path d="M13.3457 13.3457L15.3874 15.3874" stroke="#FDBF5A" strokeWidth="2"/>
    <path d="M20.7256 14.8015L18.6839 16.8432" stroke="#FDBF5A" strokeWidth="2"/>
  </svg>
);

export default CardLogo;
